/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import GlucoUser from './gluco-user';
import GlucoUserDetail from './gluco-user-detail';
import GlucoUserUpdate from './gluco-user-update';
import GlucoUserDeleteDialog from './gluco-user-delete-dialog';

const GlucoUserRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<GlucoUser />} />
    <Route path="new" element={<GlucoUserUpdate />} />
    <Route path=":id">
      <Route index element={<GlucoUserDetail />} />
      <Route path="edit" element={<GlucoUserUpdate />} />
      <Route path="delete" element={<GlucoUserDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default GlucoUserRoutes;
